import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { filter } from 'lodash-es';
import BalanceSelector from '@/components/cms/custom/BlockIngredients/BalanceSelector.vue';
import VolumeSelector from '@/components/cms/custom/BlockIngredients/VolumeSelector.vue';
import IngredientsList from '@/components/cms/custom/BlockIngredients/IngredientsList.vue';
import EquipmentList from '@/components/cms/custom/BlockIngredients/EquipmentList.vue';
import RichText from '~/components/ui/RichText.vue';
import { recipeIngredientsStore } from '@/store/RecipeIngredientsStore';
import { ActiveTabs, BalanceOptions, BalanceOptionsAmountType } from '@/types/RecipeIngredients';
import AzTab from '~/components/_next/molecules/AzTab.vue';
import AzTabs from '~/components/_next/molecules/AzTabs.vue';
import { useProduct } from '~/composables/_next/useProduct';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockIngredients',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    subTitle: {
      type: String,
      required: false,
      default: ''
    },
    subBlockTitle: {
      type: String,
      required: false,
      default: ''
    },
    subBlockContent: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var store = recipeIngredientsStore;
    var _useProduct = useProduct('productIngredients'),
      productIngredients = _useProduct.products;
    var _useProduct2 = useProduct('productEquipments'),
      productEquipments = _useProduct2.products;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var getCategoriesSlugs = function getCategoriesSlugs(categories) {
      return categories === null || categories === void 0 ? void 0 : categories.map(function (_ref) {
        var slug = _ref.slug;
        return slug;
      });
    };
    var getObjectFromProduct = function getObjectFromProduct(product) {
      var _product$images$;
      var productCategoriesSlugs = getCategoriesSlugs(product === null || product === void 0 ? void 0 : product._categories);
      return {
        sku: product === null || product === void 0 ? void 0 : product.sku,
        name: product === null || product === void 0 ? void 0 : product._name,
        image: product === null || product === void 0 ? void 0 : (_product$images$ = product.images[0]) === null || _product$images$ === void 0 ? void 0 : _product$images$.url,
        slug: product === null || product === void 0 ? void 0 : product._slug,
        isEssentialOil: useHasEssentialOilsCategory(productCategoriesSlugs)
      };
    };
    var prepareTranslateLabel = function prepareTranslateLabel(key) {
      return {
        label: i18n.t("rdp.".concat(key)),
        code: key
      };
    };
    var ingredients = inject('ingredients', ref([]));
    var equipmentsWithBalance = inject('equipmentsWithBalance', ref([]));
    var equipmentsWithoutBalance = inject('equipmentsWithoutBalance', ref([]));
    var activeTab = ref('ingredients');
    /**
     * Sets the active tab
     *
     * @param      {string}  id      The identifier
     */
    function selectTab(id) {
      activeTab.value = id;
    }
    var modifyEquipments = function modifyEquipments(equipments, hasBalance) {
      if (!Array.isArray(equipments) || !equipments.length) {
        return [];
      }
      return equipments.map(function (equipment) {
        return _objectSpread(_objectSpread({}, equipment), {}, {
          fields: _objectSpread(_objectSpread({}, equipment.fields), {}, {
            balance: hasBalance ? BalanceOptions.withBalance : BalanceOptions.withoutBalance
          })
        });
      });
    };
    watch(equipmentsWithBalance, function () {
      modifyEquipments(equipmentsWithoutBalance.value, true);
    });
    watch(equipmentsWithoutBalance, function () {
      modifyEquipments(equipmentsWithoutBalance.value, false);
    });
    var checkAmount = function checkAmount(product, amountType) {
      var _product$quantities, _product$quantities$, _product$quantities$$, _product$quantities$$2, _product$quantities$$3, _product$quantities$$4;
      return product === null || product === void 0 ? void 0 : (_product$quantities = product.quantities) === null || _product$quantities === void 0 ? void 0 : (_product$quantities$ = _product$quantities[0]) === null || _product$quantities$ === void 0 ? void 0 : (_product$quantities$$ = _product$quantities$.fields) === null || _product$quantities$$ === void 0 ? void 0 : (_product$quantities$$2 = _product$quantities$$.amounts) === null || _product$quantities$$2 === void 0 ? void 0 : (_product$quantities$$3 = _product$quantities$$2[0]) === null || _product$quantities$$3 === void 0 ? void 0 : (_product$quantities$$4 = _product$quantities$$3.fields) === null || _product$quantities$$4 === void 0 ? void 0 : _product$quantities$$4[amountType];
    };
    var balanceOptionsPresence = computed(function () {
      return {
        withBalance: {
          isPresent: allIngredients.value.some(function (ingredient) {
            return checkAmount(ingredient, BalanceOptionsAmountType.withBalance);
          })
        },
        withoutBalance: {
          isPresent: allIngredients.value.some(function (ingredient) {
            return checkAmount(ingredient, BalanceOptionsAmountType.withoutBalance);
          })
        },
        percentage: {
          isPresent: allIngredients.value.some(function (ingredient) {
            return checkAmount(ingredient, BalanceOptionsAmountType.percentage);
          })
        }
      };
    });
    var allIngredients = computed(function () {
      return ingredients.value.map(function (ingredient) {
        var _ingredient$fields2;
        var currentIngredient = productIngredients.value.find(function (_ref2) {
          var _ingredient$fields;
          var sku = _ref2.sku;
          return sku == ((_ingredient$fields = ingredient.fields) === null || _ingredient$fields === void 0 ? void 0 : _ingredient$fields.ingredientSku);
        });
        if (!currentIngredient && !(ingredient !== null && ingredient !== void 0 && (_ingredient$fields2 = ingredient.fields) !== null && _ingredient$fields2 !== void 0 && _ingredient$fields2.nonPurchasableIngredient)) {
          return undefined;
        }
        return _objectSpread(_objectSpread({}, ingredient.fields), getObjectFromProduct(currentIngredient));
      }).filter(function (e) {
        return e;
      });
    });
    var combinedEquipment = computed(function () {
      return [].concat(_toConsumableArray(modifyEquipments(equipmentsWithBalance.value, true)), _toConsumableArray(modifyEquipments(equipmentsWithoutBalance.value, false)));
    });
    var allEquipment = computed(function () {
      var _store$balanceOption;
      var currentBalance = ((_store$balanceOption = store.balanceOption) === null || _store$balanceOption === void 0 ? void 0 : _store$balanceOption.code) || null;
      if (currentBalance) {
        return combinedEquipment.value.map(function (equipment) {
          var currentEquipment = productEquipments.value.find(function (_ref3) {
            var _equipment$fields;
            var sku = _ref3.sku;
            return sku == ((_equipment$fields = equipment.fields) === null || _equipment$fields === void 0 ? void 0 : _equipment$fields.equipmentSku);
          });
          return _objectSpread(_objectSpread({}, equipment.fields), getObjectFromProduct(currentEquipment));
        }).filter(function (equipment) {
          return equipment.balance == currentBalance;
        });
      }
      return [];
    });
    var balanceOptions = computed(function () {
      var equipmentsOption = activeTab.value == ActiveTabs.equipments ? null : prepareTranslateLabel(BalanceOptions.percentage);
      var balance = filter([prepareTranslateLabel(BalanceOptions.withBalance), prepareTranslateLabel(BalanceOptions.withoutBalance), equipmentsOption]);
      return balance.filter(function (option) {
        return (option === null || option === void 0 ? void 0 : option.code) && balanceOptionsPresence.value[option.code].isPresent;
      });
    });
    var isWatchExecuted = false;
    watch(balanceOptions, function () {
      if (!isWatchExecuted) {
        store.setBalanceOption(balanceOptions.value[0]);
        isWatchExecuted = true;
      }
    }, {
      immediate: true
    });
    var uniqueQuantities = computed(function () {
      var unique = [];
      allIngredients.value.map(function (ingredient) {
        var availableQuantities = [];
        if (Array.isArray(ingredient === null || ingredient === void 0 ? void 0 : ingredient.quantities)) {
          availableQuantities = ingredient === null || ingredient === void 0 ? void 0 : ingredient.quantities.map(function (quantity) {
            var _quantity$fields, _quantity$fields$Quan, _quantity$fields$Quan2, _quantity$fields2, _quantity$fields2$Qua, _quantity$fields2$Qua2;
            return {
              label: quantity === null || quantity === void 0 ? void 0 : (_quantity$fields = quantity.fields) === null || _quantity$fields === void 0 ? void 0 : (_quantity$fields$Quan = _quantity$fields.QuantityToCreate) === null || _quantity$fields$Quan === void 0 ? void 0 : (_quantity$fields$Quan2 = _quantity$fields$Quan.fields) === null || _quantity$fields$Quan2 === void 0 ? void 0 : _quantity$fields$Quan2.quantityToCreate,
              code: quantity === null || quantity === void 0 ? void 0 : (_quantity$fields2 = quantity.fields) === null || _quantity$fields2 === void 0 ? void 0 : (_quantity$fields2$Qua = _quantity$fields2.QuantityToCreate) === null || _quantity$fields2$Qua === void 0 ? void 0 : (_quantity$fields2$Qua2 = _quantity$fields2$Qua.sys) === null || _quantity$fields2$Qua2 === void 0 ? void 0 : _quantity$fields2$Qua2.id
            };
          });
        }
        return _objectSpread({}, availableQuantities);
      }).forEach(function (element) {
        Object.entries(element).forEach(function (item) {
          unique.push(item[1]);
        });
      });
      return unique;
    });
    var volumeOptions = computed(function () {
      return _toConsumableArray(new Map(uniqueQuantities.value.map(function (value) {
        return [value.code, value];
      })).values());
    });
    var hasListOfVolumeOptions = computed(function () {
      return volumeOptions.value.length;
    });
    var setVolumeOption = function setVolumeOption() {
      var _volumeOptions$value;
      store.setVolumeOption(volumeOptions === null || volumeOptions === void 0 ? void 0 : (_volumeOptions$value = volumeOptions.value) === null || _volumeOptions$value === void 0 ? void 0 : _volumeOptions$value[0]);
    };
    setVolumeOption();
    watch(volumeOptions, function () {
      setVolumeOption();
    });
    var isSubBlockEmpty = computed(function () {
      var _props$subBlockConten, _props$subBlockConten2;
      return !(props !== null && props !== void 0 && props.subBlockContent) || !(props !== null && props !== void 0 && (_props$subBlockConten = props.subBlockContent) !== null && _props$subBlockConten !== void 0 && (_props$subBlockConten2 = _props$subBlockConten.content) !== null && _props$subBlockConten2 !== void 0 && _props$subBlockConten2.length);
    });
    return {
      __sfc: true,
      props: props,
      store: store,
      productIngredients: productIngredients,
      productEquipments: productEquipments,
      i18n: i18n,
      getCategoriesSlugs: getCategoriesSlugs,
      getObjectFromProduct: getObjectFromProduct,
      prepareTranslateLabel: prepareTranslateLabel,
      ingredients: ingredients,
      equipmentsWithBalance: equipmentsWithBalance,
      equipmentsWithoutBalance: equipmentsWithoutBalance,
      activeTab: activeTab,
      selectTab: selectTab,
      modifyEquipments: modifyEquipments,
      checkAmount: checkAmount,
      balanceOptionsPresence: balanceOptionsPresence,
      allIngredients: allIngredients,
      combinedEquipment: combinedEquipment,
      allEquipment: allEquipment,
      balanceOptions: balanceOptions,
      isWatchExecuted: isWatchExecuted,
      uniqueQuantities: uniqueQuantities,
      volumeOptions: volumeOptions,
      hasListOfVolumeOptions: hasListOfVolumeOptions,
      setVolumeOption: setVolumeOption,
      isSubBlockEmpty: isSubBlockEmpty,
      BalanceSelector: BalanceSelector,
      VolumeSelector: VolumeSelector,
      IngredientsList: IngredientsList,
      EquipmentList: EquipmentList,
      RichText: RichText,
      AzTab: AzTab,
      AzTabs: AzTabs
    };
  }
});